import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#496E2D",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M14.087 11.5c-.294 0-.574.06-.834.153.143-.318.238-.67.238-1.047 0-1.49-1.49-2.609-1.49-2.609s-1.491 1.118-1.491 2.609c0 .377.095.73.237 1.047a2.5 2.5 0 0 0-.834-.153c-1.49 0-2.608 1.491-2.608 1.491s1.118 1.49 2.608 1.49c.874 0 1.62-.511 2.087-.935.468.424 1.213.936 2.087.936 1.491 0 2.609-1.491 2.609-1.491s-1.118-1.49-2.609-1.49"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "m12 4.695.308.947h.996l-.806.586.308.948L12 6.59l-.806.586.307-.948-.806-.586h.997zM8.212 6.352l.592.533.69-.399-.323.729.592.533-.793-.083-.324.728-.166-.78-.793-.083.69-.399zM5.438 9.126l.78.166.398-.69.083.792.78.166-.728.324.083.793-.534-.592-.728.324.399-.69zM15.79 6.352l-.593.533-.69-.399.324.729-.593.533.793-.083.324.728.166-.78.793-.083-.69-.399zM18.565 9.126l-.78.166-.398-.69-.084.792-.78.166.729.324-.084.793.534-.592.728.324-.399-.69z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12.003 18.656a5.2 5.2 0 0 0 3.15-1.06H8.853a5.2 5.2 0 0 0 3.15 1.06M7.219 15.524q.25.57.622 1.06h8.321c.247-.325.457-.68.622-1.06z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }